import app from "./app";
import { logger } from "./lib/logger";

const rawPort = process.env["PORT"];

if (!rawPort) {
  throw new Error(
    "PORT environment variable is required but was not provided.",
  );
}

const port = Number(rawPort);

if (Number.isNaN(port) || port <= 0) {
  throw new Error(`Invalid PORT value: "${rawPort}"`);
}

async function warmCache() {
  const base = `http://localhost:${port}/api/splay`;
  const endpoints = [
    "/dramas/popular?per_page=40",
    "/dramas/trending?per_page=40",
    "/dramas?per_page=40&sort_by=updated_at&sort_order=desc",
    "/dramas?per_page=40&language=ko",
    "/dramas?per_page=40&language=zh",
    "/anime/home",
    "/anime/popular?per_page=30",
    "/anime/latest-update?per_page=30",
  ];
  for (const ep of endpoints) {
    try {
      await fetch(base + ep);
      logger.info({ ep }, "Cache warmed");
    } catch (_) {}
  }
}

app.listen(port, (err) => {
  if (err) {
    logger.error({ err }, "Error listening on port");
    process.exit(1);
  }

  logger.info({ port }, "Server listening");

  setTimeout(() => {
    warmCache().catch(() => {});
  }, 2000);
});
